import { z } from 'zod';
import { BaseFlowDecorationSchema, FlowDecorationType } from './base.js';
import { FlowDecorationColor } from './constants.js';
export const FlowGroupNodeDataSchema = z.object({
    label: z.string().default(''),
    color: z.enum(FlowDecorationColor).default(FlowDecorationColor.Purple),
});
export const FlowGroupNodeSchema = BaseFlowDecorationSchema.extend({
    decorationType: z.literal(FlowDecorationType.GroupNode),
    data: FlowGroupNodeDataSchema,
    dimensions: z.object({
        width: z.number().default(240).optional(),
        height: z.number().default(240).optional(),
    }),
});
//# sourceMappingURL=groupNode.js.map